import { alpha, Theme, styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { ColorVariant, LabelColor, LabelVariant } from './types';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) && !['customState'].includes(prop as string);
export const StyledLabel = styled(Box, {
    shouldForwardProp: customShouldForwardProp,
})(({
    theme,
    customState,
}: {
    theme: Theme;
    customState: {
        color: LabelColor;
        variant: LabelVariant;
        colorVariant: ColorVariant;
    };
}) => {
    const isLight = theme.palette.mode === 'light';
    const filledVariant = customState.variant === 'filled';
    const outlinedVariant = customState.variant === 'outlined';
    const softVariant = customState.variant === 'soft';
    const defaultStyle = {
        ...(customState.color === 'default' && {
            ...(outlinedVariant && {
                backgroundColor: 'transparent',
                color: theme.palette.text.primary,
                border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
            }),
            ...(softVariant && {
                color: isLight
                    ? theme.palette.text.primary
                    : theme.palette.common.white,
                backgroundColor: alpha(theme.palette.grey[500], 0.16),
            }),
        }),
    };

    const colorStyle = {
        ...(customState.color !== 'default' && {
            ...(filledVariant && {
                color: theme.palette[customState.color].contrastText,
                backgroundColor:
                    customState.colorVariant === 'light'
                        ? theme.palette[customState.color].light
                        : theme.palette[customState.color].main,
            }),
            ...(outlinedVariant && {
                backgroundColor: 'transparent',
                color:
                    customState.colorVariant === 'light'
                        ? theme.palette[customState.color].light
                        : theme.palette[customState.color].main,
                border: `1px solid ${theme.palette[customState.color].main}`,
            }),
            ...(softVariant && {
                color: theme.palette[customState.color][
                    isLight ? 'dark' : 'light'
                ],
                backgroundColor: alpha(
                    theme.palette[customState.color].main,
                    0.16
                ),
            }),
        }),
    };

    return {
        height: 24,
        minWidth: 22,
        lineHeight: 0,
        borderRadius: 6,
        cursor: 'default',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        justifyContent: 'center',
        textTransform: 'capitalize',
        padding: theme.spacing(0, 1),
        color: theme.palette.grey[800],
        fontSize: theme.typography.pxToRem(12),
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.grey[300],
        fontWeight: theme.typography.fontWeightBold,
        ...colorStyle,
        ...defaultStyle,
    };
});
